import { Link } from "react-router-dom";
import Seo from "../components/site/Seo";

export default function NotFound() {
  return (
    <main className="min-h-[80vh] pt-40 pb-24 max-w-[1400px] mx-auto px-5 lg:px-10" data-testid="page-404">
      <Seo title="Page introuvable | Moustique Bordeaux" description="Cette page n'existe pas." path="/404" noindex />
      <p className="eyebrow text-sage">Erreur 404</p>
      <h1 className="mt-5 font-display text-5xl lg:text-8xl font-extrabold text-forest leading-[0.9]">Cette page s'est <span className="serif-i font-normal">envolée.</span></h1>
      <div className="mt-10 flex flex-wrap gap-3">
        <Link to="/" className="btn btn-forest">Retour à l'accueil</Link>
        <Link to="/contact" className="btn btn-ghost">Demander un devis</Link>
      </div>
    </main>
  );
}
